import { useController, UseControllerProps } from 'react-hook-form';

import { FormControl } from '@material-ui/core';
import {
  Box,
  FormHelperText,
  IconButton,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import {
  LocalizationProvider,
  MobileDatePicker,
  MobileDatePickerProps,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EventIcon from '@mui/icons-material/Event';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import ptBR from 'date-fns/locale/pt-BR';

interface Props
  extends Partial<MobileDatePickerProps<Date | string, Date>>,
    UseControllerProps {
  name: string;
  required?: boolean;
  defaultValue?: any;
  disabled?: boolean;
  label?: string;
  size?: 'medium' | 'small';
}

export const DatePickerSelectInput: React.FC<Props> = ({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  required,
  label,
  size = 'medium',
  ...props
}) => {
  const { field, fieldState } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });
  const [date, setDate] = useState<Date | null>(null);

  useEffect(() => {
    setDate(field.value);
  }, [field.value]);

  return (
    <FormControl error={Boolean(fieldState.error?.message)} fullWidth>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
        <MobileDatePicker
          {...props}
          value={date}
          label={label}
          onChange={setDate}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              size={size}
              onBlur={field.onBlur}
              InputProps={{
                endAdornment: (
                  <Stack direction="row" alignItems="center">
                    <Box width={38}>
                      {date ? (
                        <Tooltip title="Limpar">
                          <IconButton
                            size="small"
                            onClick={(event) => {
                              event.preventDefault();
                              event.stopPropagation();
                              field.onChange(null);
                            }}
                          >
                            <CloseIcon htmlColor="#8E8E8E" />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </Box>

                    <EventIcon htmlColor="#8E8E8E" />
                  </Stack>
                ),
                ...params.InputProps,
              }}
            />
          )}
          onAccept={(date) => {
            field.onChange(date);
          }}
        />
      </LocalizationProvider>

      {fieldState.error?.message ? (
        <FormHelperText error={true}>
          {fieldState.error?.message}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};
